(window.ScrollingImages = function (Behaviors) {

  "use strict";
  
  function ScrollingImages(elem) {
    Behaviors.init(ScrollingImages, this, arguments)

    this.scrollSlider = this.$elem[0];

    const scrollSlider = new Swiper(this.scrollSlider, {
      wrapperClass: 'scrolling-images__track',
      slideClass: 'scrolling-images__slide',
      speed: 2500,
      autoplay: {
        delay: 500,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 17,
          loop: true
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 17,
          loop: true
        }
      }
    });
    
  }

  Behaviors.inherit(ScrollingImages, Behaviors.Behavior);
  ScrollingImages.QUERY = '.scrolling-images';

  Behaviors.register_behavior(ScrollingImages);
  
  return ScrollingImages;

  }(window.Behaviors));